import React from 'react';

var SvgReplaceMajor = function SvgReplaceMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5h5a1.5 1.5 0 0 0 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5h-5zm11.793 7.707a1 1 0 1 0 1.414-1.414l-1.293-1.293h4.086a.5.5 0 0 1 .5.5v3.5a1 1 0 1 0 2 0v-3.5a2.5 2.5 0 0 0-2.5-2.5h-4.086l1.293-1.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3zm-6.586 4.586a1 1 0 0 0-1.414 1.414l1.293 1.293h-4.086a.5.5 0 0 1-.5-.5v-3.5a1 1 0 1 0-2 0v3.5a2.5 2.5 0 0 0 2.5 2.5h4.086l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3zm13.293 6.207a1.5 1.5 0 0 1-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5v-5a1.5 1.5 0 0 1 1.5-1.5h5a1.5 1.5 0 0 1 1.5 1.5v5z"
  }));
};

export { SvgReplaceMajor as S };
